<script>
import dataTranslator from "../library/data-translator";
import Turbolinks from "turbolinks";

export default {
    props: {
        cancelUrl: {
            default() {
                return prev_url ?? base_url;
            },
        },
    },
    mounted() {
        this.$el
            .querySelectorAll("[id], [for]")
            .forEach((item, index, sourceArr) => {
                if (item.hasAttribute("id"))
                    item.setAttribute(
                        "id",
                        `${this._uid}-${item.getAttribute("id")}`
                    );
                if (item.hasAttribute("for"))
                    item.setAttribute(
                        "for",
                        `${this._uid}-${item.getAttribute("for")}`
                    );
            });
    },
    methods: {
        printLog() {
            console.log(...arguments);
        },
        cloneVar: dataTranslator.cloneVariable,
        goToCancel() {
            Turbolinks.visit(this.cancelUrl);
        }
    }
};
</script>
